import React, { useEffect, useState } from "react";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GeneralInstructions from "../GeneralInstructions";
import {
  AddApplication,
  GetApplicationInformation,
} from "../../../Redux/Reducers/Shared/ApplicationInformation";

const MainPage = () => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const navigate = useNavigate();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const [canClick, setCanClick] = useState(true);
  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      //   ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  //   useEffect(() => {
  //     dispatch(GetActiveRound());
  //   }, []);
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusNameAr",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "roundName",
      ShowStatus: true,
      NmaeColumn: "سنة التقدم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        localStorage.setItem("ApplicationInformationId", e.target.value);
        // بعد انتهاء التحميل

        const applicantinfo = await dispatch(
          GetApplicationInformation({
            applicationInformationId: e.target.value,
          })
        );
        console.log(applicantinfo.payload, "applicantinfo");
        //اذا كانت موافق على الشروط ينقله الى الطلب اذا غير موافق يظهر له
        //popup  التعليمات العامة
        if (applicantinfo && !applicantinfo.payload?.terms) {
          SetPopupComponentStatus(true);
        } else {
          SetPopupComponentStatus(false);
          navigate("/SRFund/MainResearcherInformainContainer");
        }
      },
      content: "عرض الطلب",
      className: "bi bi-eye-fill",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      ForSpecific: true,
      ForSpecificLineName: "applicationInformationId",
    },
    
    {
      Click: async (e) => {
        SetPopupComponentStatus(true);
      },
      content: " انشاء طلب جديد ",
      className: "bi bi-plus-square-fill",
      id: "AddAppBtn",
      title: "عرض",
      ShowStatus: canClick,
      ForSpecificLineStatus: true,
      ForSpecificLineId: "00000000-0000-0000-0000-000000000000",
      ForSpecificLineName: "applicationInformationId",
    },
  ];

  const RequestsColumns = [];
  // send to read props popup

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>csalmkmkmkkmcskak</div>,
    maxWidth: "100px",
    maxHeight: "100px",
  };
  //to get json data from main.json
  //   const getJson = async () => {
  //     var json = await loadConfig();
  //     //console.log(json, "jjjjj");
  //     setJsonData(json);
  //     return json;
  //   };
  //   useEffect(() => {
  //     getJson();
  //   }, []);

  const closePopupComponent = () => {
    SetPopupComponentStatus(false);
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"applicationInformationId"}
        valueButtonAction={"applicationInformationId"}
        URL={`api/SU_NT_MRI_ApplicationInformationModel/ReturnApplication`}
        // UrlBody={{
        //   ApplicationInformationId: "string",
        // }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"التعليمات العامة"}
        componentBody={<GeneralInstructions />}
        maxWidth={"70%"}
        maxHeight={"635px"}
        isPopupOpenStatus={PopupComponentStatus}
        isPopupOpenFunction={closePopupComponent}
      />
      <LoaderAHSF show={!canClick} />
    </>
  );
};

export default MainPage;
